/* eslint-disable no-unused-vars */
export default {
  setDosingEntriesToStore({ commit }, DosingEntries) {
    commit('setDosingEntriesToStore', DosingEntries);
    commit('setDosingEntriesBackupToStore', DosingEntries);
  },
  revertDosingChange({ commit }, dosingKey) {
    commit('revertDosingChange', dosingKey);
  },
  changeBackedUpDosing({ commit }, dosingKey) {
    commit('changeBackedUpDosing', dosingKey);
  },
  switchDosingRatePumpCycles({ commit }, dosingKey) {
    commit('switchDosingRatePumpCycles', dosingKey);
  },
  switchPumpCyclesDosingRate({ commit }, dosingKey) {
    commit('switchPumpCyclesDosingRate', dosingKey);
  },
  switchGPDPPM({ commit }, dosingKey) {
    commit('switchGPDPPM', dosingKey);
  },
  switchPPMGPD({ commit }, dosingKey) {
    commit('switchPPMGPD', dosingKey);
  },
  changeCountedValue({ commit }, { dosingKey, targetValue, value }) {
    commit('changeCountedValue', { dosingKey, targetValue, value });
  },
  changeCountedRateTypeValue({ commit }, {
    dosingKey, dosingRateType, targetValue, value,
  }) {
    commit('changeCountedRateTypeValue', {
      dosingKey, dosingRateType, targetValue, value,
    });
  },
  switchDosingRateManualAuto({ commit }, dosingKey) {
    commit('switchDosingRateManualAuto', dosingKey);
  },
  switchDosingRateAutoManual({ commit }, dosingKey) {
    commit('switchDosingRateAutoManual', dosingKey);
  },
  switchDosingRateMCFDBBLD({ commit }, dosingKey) {
    commit('switchDosingRateMCFDBBLD', dosingKey);
  },
  switchDosingRateBBLDMCFD({ commit }, dosingKey) {
    commit('switchDosingRateBBLDMCFD', dosingKey);
  },
  switchDosingRatePPMGPD({ commit }, dosingKey) {
    commit('switchDosingRatePPMGPD', dosingKey);
  },
  switchDosingRateGPDPPM({ commit }, dosingKey) {
    commit('switchDosingRateGPDPPM', dosingKey);
  },
};
